// extracted by mini-css-extract-plugin
export var actionsContainer = "SwapMyBox_actionsContainer__poOZU";
export var contactToUnswap = "SwapMyBox_contactToUnswap__6CrFk";
export var disclaimer = "SwapMyBox_disclaimer__Pr9wJ";
export var faqAnswer = "SwapMyBox_faqAnswer__kXMc0";
export var faqContainer = "SwapMyBox_faqContainer__GHxaw";
export var faqQuestion = "SwapMyBox_faqQuestion__TK9K-";
export var faqTitle = "SwapMyBox_faqTitle__pw5Uq";
export var mainContent = "SwapMyBox_mainContent__Y2EOJ";
export var mainContentContainer = "SwapMyBox_mainContentContainer__teirD";
export var mainText = "SwapMyBox_mainText__Cdle1";
export var mainTextItem = "SwapMyBox_mainTextItem__x9PAd";
export var md = "768px";
export var mobileImage = "SwapMyBox_mobileImage__XDPQf";
export var seeDetails = "SwapMyBox_seeDetails__5nFa0";
export var shared = "'../../shared.module.css'";
export var stillQuestions = "SwapMyBox_stillQuestions__v8mPb";
export var swapForCredit = "SwapMyBox_swapForCredit__7V6Z2";
export var swapMyBoxContainer = "SwapMyBox_swapMyBoxContainer__EdpBj";
export var swappedDate = "SwapMyBox_swappedDate__KJG2r";
export var title = "SwapMyBox_title__Ej8BZ";
export var visitFaq = "SwapMyBox_visitFaq__Cmh6A";